<mat-expansion-panel [expanded]="expanded">
	<mat-expansion-panel-header *ngIf="!employee">
		<mat-panel-title>System User Notifications</mat-panel-title>
		<mat-panel-description>Notifications sent to system users when employees take certain actions</mat-panel-description>
	</mat-expansion-panel-header>
	<mat-expansion-panel-header *ngIf="employee">
		<mat-panel-title>Employee Notifications</mat-panel-title>
		<mat-panel-description>Notifications sent to employees automatically or when system users take certain actions</mat-panel-description>
	</mat-expansion-panel-header>

	<form #notificationsForm="ngForm" (ngSubmit)="notificationsForm.valid && save()">
		<mat-table [dataSource]="notifications">
			<ng-container matColumnDef="Description">
				<mat-header-cell *matHeaderCellDef>
					<span class="column-text">Notification</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let notification">
					{{ notification.Description }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="InApp">
				<mat-header-cell *matHeaderCellDef>
					<span class="column-text">In-App</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let notification">
					<mat-slide-toggle [disabled]="isReadOnly" [name]="'InApp-' + notification.Id" class="linq-slide-toggle" color="primary"
						[(ngModel)]="notification.InApp">
					</mat-slide-toggle>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="Email">
				<mat-header-cell *matHeaderCellDef>
					<span class="column-text">Email</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let notification">
					<mat-slide-toggle [disabled]="isReadOnly" [name]="'Email-' + notification.Id" class="linq-slide-toggle" color="primary"
						[(ngModel)]="notification.Email">
					</mat-slide-toggle>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="Frequency">
				<mat-header-cell *matHeaderCellDef>
					<span class="column-text">Email Frequency</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let notification">
					<mat-form-field>
						<mat-select [disabled]="isReadOnly || !notification.Email" [name]="'Frequency-' + notification.Id"
							[(ngModel)]="notification.FrequencyId">
							<mat-option *ngFor="let f of frequencies; trackById" [value]="f.value">
								{{ f.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>

				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="Recipients">
				<mat-header-cell *matHeaderCellDef>
					<span class="column-text">Recipients</span>
				</mat-header-cell>
				<mat-cell *matCellDef="let notification">
					<button *ngIf="!isReadOnly" mat-button color="primary" title="Add Recipients" type="button" (click)="openFlyout(notification)"
						class="offset-lg-10">
						<span class="link">Select</span>
					</button>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="columnsToDisplay(); sticky: true"></mat-header-row>
			<mat-row *matRowDef="let row; columns: columnsToDisplay()"></mat-row>
		</mat-table>
		<footer class="linq-drawer-footer" *ngIf="notificationsForm.dirty">
			<button type="button" mat-stroked-button color="primary" class="linq-button--secondary" (click)="cancel()">Cancel</button>
			<button type="submit" mat-raised-button color="primary">
				Save
			</button>
		</footer>
	</form>
</mat-expansion-panel>
<sl-form [fields]="fields" [options]="options" [form]="form" [editOnly]="true" (submitted)="onSubmit($event)"></sl-form>
